import * as ACTIONS from '../constants/options';

export const setOption = source => dispatch => {
  window.sessionStorage.setItem('source', source);
  return dispatch({
    type: ACTIONS.OPTIONS.SET,
    payload: {
      source,
    },
  });
};

export const clearOption = () => dispatch => {
  window.sessionStorage.removeItem('source');
  return dispatch({
    type: ACTIONS.OPTIONS.CLEAR,
    payload: {
      source: '',
    },
  });
};
